import Head from 'next/head';
import { labels } from 'ui/data/constants/labels';
import { AuthProvider } from '@cogitate/diep2-components-core';
import { getStoreState, setStoreState } from '@cogitate/ui-multi-utils';
import { storeKeys, routeKeys } from 'ui/data/constants/keys';
import { useRouter } from 'next/router';
import { LoadPolicyDetailsByInsuredEmail } from 'ui/utilities/helper';
import { toast } from 'react-toastify';
import { getMasterFromBlobAndDB } from 'ui/utilities/getMasterFromBlobAndDB';

export default function CustomerPortal() {
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
  const router = useRouter();

  const onSuccess = async (response) => {
    if (!response || Object.keys(response).length === 0) {
      const searchParams = new URLSearchParams(window.location.search);
      const errorParams = searchParams.get('error');

      // when clicked on cancel button in SSO login page, redirecting back to login page
      if (
        ['invalid_authorization_response', 'token_retrival_error'].includes(
          errorParams
        )
      ) {
        window.location.search = '';
      }
      return;
    }
    if (
      response?.decodedJWT?.role &&
      response?.decodedJWT?.role !== 'Insured'
    ) {
      setStoreState(storeKeys.LoggedInUserReducer, response);
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return;
    }
    if (response?.decodedJWT?.email) {
      response.JWTValidTill = response?.JWTValidTill.getTime();
      setStoreState(storeKeys.LoggedInUserReducer, response);
      await getMasterFromBlobAndDB();
      const resp = await LoadPolicyDetailsByInsuredEmail(
        response.decodedJWT.email
      );
      if (!resp) {
        toast.error(`No records found. Please enter valid details.`);
      } else if (resp.length === 1) {
        const selectedPolicy = resp[0];
        setStoreState(storeKeys.PolicyReducer, selectedPolicy);
        router.push(routeKeys.ApplicationSummary.toLowerCase());
      } else {
        router.push(routeKeys.DashboardAccountHub.toLowerCase());
      }
    }
  };

  return (
    <>
      <Head>
        <title>{labels.Shared.CustomerPortal.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link
          rel="icon"
          href={`${process.env.NEXT_PUBLIC_CDN_IMAGE_PATH}/${process.env.NEXT_PUBLIC_AZURE_IMAGE_STYLE_STORAGE_ACCOUNT_NAME}/${process.env.NEXT_PUBLIC_CLIENT}/${process.env.NEXT_PUBLIC_ASSESTS_IMAGES}/favicon-embark.png`}
        />
      </Head>

      <AuthProvider
        AuthUrl={
          process.env.NEXT_PUBLIC_EMBARKMH_SSO_URL +
          process.env.NEXT_PUBLIC_PROJECT_URL +
          '/customerportal&redirectSlug=true'
        }
        UserStore={loggedInUser}
        onSuccess={onSuccess}
      ></AuthProvider>
    </>
  );
}

CustomerPortal.layout = 'L1';
